<template>
  <div>
    <Head title="Profil aktualisieren"/>
    <div class="flex justify-start mb-4 md:mb-8 max-w-3xl">
      <h1 class="text-xl md:text-3xl font-bold">
        <Link class="text-primary-400 hover:text-primary-600" href="/users">Profil aktualisieren</Link>
        <span class="text-primary-400 font-medium">/</span>
        {{ form.first_name }} {{ form.last_name }}
      </h1>
      <img v-if="user.photo" class="block ml-4 w-8 h-8 rounded-full" :src="user.photo"/>
    </div>
    <trashed-message v-if="user.deleted_at" class="mb-6" @restore="restore"> This user has been deleted.
    </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap md:-mb-8 md:-mr-6 p-5 md:p-8 text-sm md:text-base">
          <text-input v-model="form.first_name" :error="form.errors.first_name"
                      class="pb-4 pr-4 md:pb-8 md:pr-6 w-full lg:w-1/2" :label="__('general.firstname')"
          />
          <text-input v-model="form.last_name" :error="form.errors.last_name"
                      class="pb-4 pr-4 md:pb-8 md:pr-6 w-full lg:w-1/2" :label="__('general.lastname')"
          />
          <text-input v-model="form.email" :error="form.errors.email" class="pb-4 pr-4 md:pb-8 md:pr-6 w-full lg:w-1/2"
                      :label="__('general.email')"
          />

          <file-input v-model="form.photo" :error="form.errors.photo" class="pb-4 pr-4 md:pb-8 md:pr-6 w-full lg:w-1/2"
                      type="file" accept="image/*" :label="__('general.photo')"
          />
        </div>
        <div class="flex flex-col-reverse md:flex-row items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <!--          <button v-if="!user.deleted_at" class="mt-4 md:mt-0 text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">{{ __('profile.delete')}}</button>-->
          <a :href="'/users/' + user.id + '/password'"
             class="btn-secondary w-full md:w-auto block md:flex my-5 md:my-0 text-center mr-auto" type="submit"
          >{{ __('profile.update_password') }}</a>
          <loading-button :loading="form.processing"
                          class="btn-primary w-full md:w-auto flex-inline md:flex text-center ml-auto" type="submit"
          >{{ __('profile.update') }}
          </loading-button>
        </div>
      </form>
    </div>
    <a href="#" @click="destroy" class="mt-4 block link text-sm text-red-500">Benutzerkonto löschen</a>
  </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    user: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        update: 1,
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        password: '',
        owner: this.user.owner,
        photo: null,
      }),
    }
  },
  methods: {
    update() {
      this.form.post(`/users/${this.user.id}`, {
        onSuccess: () => this.form.reset('password', 'photo'),
      })
    },
    destroy() {
      if (confirm('Bist du dir sicher, dass du dieses Konto löschen willst?')) {
        this.$inertia.delete(`/users/${this.user.id}`)
      }
    },
    restore() {
      if (confirm('Willst du dieses Konto wiederherstellen?')) {
        this.$inertia.put(`/users/${this.user.id}/restore`)
      }
    },
  },
}
</script>
